import { boronClient } from "../../api";
import { useBoronMutation } from "./useBoronMutation";

export const useDeleteStaffBoardPost = ({
  sectionId,
}: {
  sectionId: string;
}) => {
  return useBoronMutation(
    async ({ staffBoardPostId }: { staffBoardPostId: string }) =>
      await boronClient.DELETE(
        "/api/v1/sections/{section_id}/staff_board_posts/{staff_board_post_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              staff_board_post_hashid: staffBoardPostId,
            },
          },
        },
      ),
  );
};
